import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      padding: [0, 0, 50],
    },
    title: {
      fontSize: theme.typography.pxToRem(19),
      lineHeight: theme.typography.pxToRem(23),
      color: theme.palette.primary.main,
      marginBottom: 8,
      textAlign: "center",
      "& span": {
        display: "block",
        fontSize: theme.typography.pxToRem(16),
        lineHeight: theme.typography.pxToRem(29),
      },
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 12,
        fontSize: theme.typography.pxToRem(19),
        lineHeight: theme.typography.pxToRem(24),
        "& span": {
          display: "inline",
          fontSize: theme.typography.pxToRem(17),
          lineHeight: theme.typography.pxToRem(20),
        },
      },
      [theme.breakpoints.up("tablet")]: {
        marginBottom: 28,
        textAlign: "left",
        fontSize: theme.typography.pxToRem(28),
        lineHeight: theme.typography.pxToRem(34),
        "& span": {
          display: "inline",
          fontSize: theme.typography.pxToRem(24),
          lineHeight: theme.typography.pxToRem(29),
        },
      },
    },
    grid: {
      marginBottom: 40,
    },
  }),
  { name: "StarringYouCards" },
);
